import { render, staticRenderFns } from "./DndPanel.vue?vue&type=template&id=87b00870&scoped=true"
import script from "./DndPanel.vue?vue&type=script&lang=js"
export * from "./DndPanel.vue?vue&type=script&lang=js"
import style0 from "./DndPanel.vue?vue&type=style&index=0&id=87b00870&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b00870",
  null
  
)

export default component.exports